var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "dashboard-container"
  }, [_c("div", {
    staticClass: "date-range-selector"
  }, [_c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY hh:mm a",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-button", {
    staticClass: "search-button",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSearch
    }
  }, [_vm._v(" Search ")])], 1), _c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticClass: "backtop-custom"
  }, [_c("i", {
    staticClass: "el-icon-arrow-up"
  })])]), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "leaderboard-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Sales Leaderboard ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadSalesExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.salesView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.toggleSalesView
    }
  })])]), _vm.salesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.top50dealersSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "dealer_name",
      label: "Name",
      width: "330"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "branch_code",
      label: "Branch",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "totalAmount",
      label: "Amount",
      width: "180"
    }
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_c("apexchart", {
    attrs: {
      type: "bar",
      height: "360",
      width: "100%",
      options: _vm.salesChartOptions,
      series: _vm.salesSeries
    }
  })], 1)], 1)])]), _c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Payments Leaderboard ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadPaymentsExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.paymentsView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.togglePaymentsView
    }
  })])]), _vm.paymentsView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.top50dealersPayments,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "dealer_name",
      label: "Name",
      width: "330"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "branch_code",
      label: "Branch",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "totalAmount",
      label: "Amount",
      width: "180"
    }
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_c("apexchart", {
    attrs: {
      type: "bar",
      height: "360",
      width: "100%",
      options: _vm.paymentsChartOptions,
      series: _vm.paymentsSeries
    }
  })], 1)], 1)])])], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" State-Wise Sales ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadStateSalesExcel
    }
  }) : _vm._e()])]), _vm.stateSalesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.stateWiseSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "address_stateId",
      label: "State ID",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "state_name",
      label: "State",
      width: "330"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "totalAmount",
      label: "Amount",
      width: "180"
    }
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isStateSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.stateWiseSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "pie",
      height: "360",
      width: "100%",
      options: _vm.stateSalesChartOptions,
      series: _vm.stateSalesSeries
    }
  })], 1)], 1)])]), _c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" State-Wise Sales ")])]), _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isStateSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.stateWiseSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "pie",
      height: "360",
      width: "100%",
      options: _vm.stateSalesChartOptions,
      series: _vm.stateSalesSeries
    }
  })], 1)])])])], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 24,
      lg: 24
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" State-Wise Range Sales ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadStateRangeSalesExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.stateRangeSalesView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.toggleStateRangeSalesView
    }
  })])]), _vm.stateRangeSalesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.stateWiseRangeSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "state",
      label: "State",
      width: "115",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.state || "Unknown") + " ")];
      }
    }], null, false, 915317122)
  }), _c("el-table-column", {
    attrs: {
      prop: "oliveSeries",
      label: "Olive Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.oliveSeries) + " ")];
      }
    }], null, false, 1736932159)
  }), _c("el-table-column", {
    attrs: {
      prop: "ouraSeries",
      label: "Oura Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.ouraSeries) + " ")];
      }
    }], null, false, 948226127)
  }), _c("el-table-column", {
    attrs: {
      prop: "deluxeSeries",
      label: "Deluxe Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.deluxeSeries) + " ")];
      }
    }], null, false, 2705501795)
  }), _c("el-table-column", {
    attrs: {
      prop: "mcbSeries",
      label: "MCB Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.mcbSeries) + " ")];
      }
    }], null, false, 1017130250)
  }), _c("el-table-column", {
    attrs: {
      prop: "lyfeSeries",
      label: "Lyfe Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.lyfeSeries) + " ")];
      }
    }], null, false, 2814825232)
  }), _c("el-table-column", {
    attrs: {
      prop: "vivaSeries",
      label: "Viva Series",
      width: "115",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.vivaSeries) + " ")];
      }
    }], null, false, 2998431374)
  }), _c("el-table-column", {
    attrs: {
      prop: "curvySeries",
      label: "Curvy Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.curvySeries) + " ")];
      }
    }], null, false, 1570351373)
  }), _c("el-table-column", {
    attrs: {
      prop: "iconnectSeries",
      label: "I-Connect Series",
      width: "115",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.iconnectSeries) + " ")];
      }
    }], null, false, 3378066705)
  }), _c("el-table-column", {
    attrs: {
      prop: "epicSeries",
      label: "Epic Series",
      width: "115",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.epicSeries) + " ")];
      }
    }], null, false, 3380640953)
  }), _c("el-table-column", {
    attrs: {
      prop: "totalSales",
      label: "Total Sales",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.totalSales) + " ")];
      }
    }], null, false, 692234871)
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isStateRangeSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.stateWiseRangeSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "bar",
      height: "400",
      width: "100%",
      options: _vm.stateRangeSalesChartOptions,
      series: _vm.stateRangeSalesSeries
    }
  })], 1)], 1)])])], 1), _c("el-row", {
    staticClass: "panel-group-sales",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 24,
      lg: 24
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Month-Wise Range Sales ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadMonthRangeSalesExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.monthRangeSalesView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.toggleMonthRangeSalesView
    }
  })])]), _vm.monthRangeSalesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.monthWiseRangeSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "month",
      label: "Month",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.month || "Unknown") + " ")];
      }
    }], null, false, 3496851685)
  }), _c("el-table-column", {
    attrs: {
      prop: "oliveSeries",
      label: "Olive Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.oliveSeries) + " ")];
      }
    }], null, false, 1736932159)
  }), _c("el-table-column", {
    attrs: {
      prop: "ouraSeries",
      label: "Oura Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.ouraSeries) + " ")];
      }
    }], null, false, 948226127)
  }), _c("el-table-column", {
    attrs: {
      prop: "deluxeSeries",
      label: "Deluxe Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.deluxeSeries) + " ")];
      }
    }], null, false, 2705501795)
  }), _c("el-table-column", {
    attrs: {
      prop: "mcbSeries",
      label: "MCB Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.mcbSeries) + " ")];
      }
    }], null, false, 1017130250)
  }), _c("el-table-column", {
    attrs: {
      prop: "lyfeSeries",
      label: "Lyfe Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.lyfeSeries) + " ")];
      }
    }], null, false, 2814825232)
  }), _c("el-table-column", {
    attrs: {
      prop: "vivaSeries",
      label: "Viva Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.vivaSeries) + " ")];
      }
    }], null, false, 2998431374)
  }), _c("el-table-column", {
    attrs: {
      prop: "curvySeries",
      label: "Curvy Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.curvySeries) + " ")];
      }
    }], null, false, 1570351373)
  }), _c("el-table-column", {
    attrs: {
      prop: "iconnectSeries",
      label: "I-Connect Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.iconnectSeries) + " ")];
      }
    }], null, false, 3378066705)
  }), _c("el-table-column", {
    attrs: {
      prop: "epicSeries",
      label: "Epic Series",
      width: "120",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.epicSeries) + " ")];
      }
    }], null, false, 3380640953)
  }), _c("el-table-column", {
    attrs: {
      prop: "totalSales",
      label: "Total Sales",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.totalSales) + " ")];
      }
    }], null, false, 692234871)
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isMonthRangeSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.monthWiseRangeSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "bar",
      height: "400",
      width: "100%",
      options: _vm.monthRangeSalesChartOptions,
      series: _vm.monthRangeSalesSeries
    }
  })], 1)], 1)])])], 1), _c("el-row", {
    staticClass: "panel-group",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Branch-Wise Sales ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadBranchSalesExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.branchSalesView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.toggleBranchSalesView
    }
  })])]), _vm.branchSalesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.branchWiseSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "branch_code",
      label: "Branch Code",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.branch_code || scope.row.branch_id || "Unknown") + " ")];
      }
    }], null, false, 1075401301)
  }), _c("el-table-column", {
    attrs: {
      prop: "branch_name",
      label: "Branch",
      width: "330"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.branch_name || "Unknown") + " ")];
      }
    }], null, false, 575681369)
  }), _c("el-table-column", {
    attrs: {
      prop: "totalAmount",
      label: "Amount",
      width: "180"
    }
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isBranchSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.branchWiseSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "pie",
      height: "360",
      width: "100%",
      options: _vm.branchSalesChartOptions,
      series: _vm.branchSalesSeries
    }
  })], 1)], 1)])]), _c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 12,
      lg: 12
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Branch-Wise Sales Graph ")])]), _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isBranchSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.branchWiseSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "pie",
      height: "360",
      width: "100%",
      options: _vm.branchSalesChartOptions,
      series: _vm.branchSalesSeries
    }
  })], 1)])])])], 1), _c("el-row", {
    staticClass: "panel-group-sales",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "chart-col",
    attrs: {
      xs: 24,
      sm: 24,
      lg: 24
    }
  }, [_c("div", {
    staticClass: "chart-wrapper"
  }, [_c("div", {
    staticClass: "line-chart-placeholder"
  }, [_c("div", {
    staticClass: "table-header"
  }, [_c("h3", {
    staticClass: "table-title"
  }, [_vm._v(" Branch-Wise Range Sales ")]), _c("div", {
    staticClass: "icon-group"
  }, [!_vm.isReadOnly ? _c("i", {
    staticClass: "el-icon-download download-icon",
    attrs: {
      title: "Download as Excel"
    },
    on: {
      click: _vm.downloadBranchRangeSalesExcel
    }
  }) : _vm._e(), _c("i", {
    staticClass: "el-icon-data-line toggle-icon",
    attrs: {
      title: _vm.branchRangeSalesView === "table" ? "Switch to Graph" : "Switch to Table"
    },
    on: {
      click: _vm.toggleBranchRangeSalesView
    }
  })])]), _vm.branchRangeSalesView === "table" ? _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.branchWiseRangeSales,
      stripe: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "branch_name",
      label: "Branch",
      width: "150",
      align: "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.branch_code || scope.row.branch_id || scope.row.branch_name || "Unknown") + " ")];
      }
    }], null, false, 909262681)
  }), _c("el-table-column", {
    attrs: {
      prop: "oliveSeries",
      label: "Olive Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "ouraSeries",
      label: "Oura Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "deluxeSeries",
      label: "Deluxe Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "mcbSeries",
      label: "MCB Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lyfeSeries",
      label: "Lyfe Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "vivaSeries",
      label: "Viva Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "curvySeries",
      label: "Curvy Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "iconnectSeries",
      label: "I-Connect Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "epicSeries",
      label: "Epic Series",
      width: "120",
      align: "center"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "totalSales",
      label: "Total Sales",
      width: "150",
      align: "center"
    }
  })], 1) : _c("div", {
    staticClass: "graph-placeholder"
  }, [_vm.isBranchRangeSalesLoading ? _c("div", {
    staticClass: "loading"
  }, [_vm._v(" Loading... ")]) : !_vm.branchWiseRangeSales.length ? _c("div", {
    staticClass: "no-data"
  }, [_vm._v(" No data available ")]) : _c("apexchart", {
    attrs: {
      type: "bar",
      height: "400",
      width: "100%",
      options: _vm.branchRangeSalesChartOptions,
      series: _vm.branchRangeSalesSeries
    }
  })], 1)], 1)])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };